export const breakpointsUnits = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1200,
  xl: 1400,
}

export const breakpoints = {
  values: breakpointsUnits,
}
